<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                                    :loading="dataForm.addLoading" v-if="page.isNew && $check(user, ['help.create'])"
                                    v-on="on" v-bind="attrs">
                                    Criar
                                </v-btn>
                            </template>
                            <span>Criar nova ajuda</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                                    :loading="dataForm.updateLoading"
                                    v-if="!page.isNew && $check(user, ['help.update'])" v-on="on" v-bind="attrs">
                                    Salvar
                                </v-btn>
                            </template>
                            <span>Salvar alterações</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined to="/ajuda"
                                    v-on="on" v-bind="attrs">
                                    Voltar
                                </v-btn>
                            </template>
                            <span>Voltar para a listagem</span>
                        </v-tooltip>
                    </div>

                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field dense label="Título" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto" counter
                                                maxlength="255"
                                                :disabled="!page.isNew && (!$check(user, ['help.update']))">
                                            </v-text-field>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="font-weight-bold">Descrição</p>
                                            <tiptap-vuetify v-model="dataset.data.description"
                                                :rules="[$rules.required]" :extensions="extensions" hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['help.update']))" />
                                            <p class="text-caption grey--text">
                                                {{ (dataset.data.description || '').length }}/500 caracteres
                                            </p>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <v-textarea label="Link" v-model="dataset.data.link" outlined dense
                                                clearable auto-grow rows="1" counter maxlength="255"
                                                :disabled="!page.isNew && (!$check(user, ['help.update']))"></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <v-row>

                                        <v-col cols="12" sm="6">
                                            <v-select style="padding-left: 4px" dense id="category"
                                                :items="dataset.categoryTypes" label="Categoria"
                                                v-model="dataset.data.category" item-value="id" item-text="name"
                                                disabled outlined hide-details="auto" 
                                                no-data-text="Nenhuma categoria disponível"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="3">
                                            <v-select style="padding-left: 4px" dense id="priority"
                                                :items="dataset.priorityTypes" label="Prioridade"
                                                v-model="dataset.data.priority" item-value="id" item-text="name"
                                                outlined hide-details="auto" :disabled="!page.isNew && (!$check(user, ['help.update']))"
                                                no-data-text="Nenhuma informação disponível"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="3">
                                            <v-select style="padding-left: 4px" dense id="is_active"
                                                :items="dataset.isActiveTypes" label="Ativo"
                                                v-model="dataset.data.is_active" item-value="id" item-text="name"
                                                outlined hide-details="auto" :disabled="!page.isNew && (!$check(user, ['help.update']))"
                                                no-data-text="Nenhuma informação disponível"></v-select>
                                        </v-col>

                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"

import categoryTypes from '@/common/data/help-categories-types.data'

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph, Link,
} from 'tiptap-vuetify'


export default {
    name: "HelpDetails",
    components: { 'tiptap-vuetify': TiptapVuetify },
    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            categoryTypes: categoryTypes,
            priorityTypes: [{ id: 1, name: 'Alta' }, {id: 2, name: 'Média'}, {id: 3, name: 'Baixa'}],
            isActiveTypes: [{ id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            data: {
                description: '',
                link: null,
                is_active: 1,
                category: 1,
                priority: 1
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Link,
            Italic,
            Bold,
            Paragraph,
        ],
    }),

    watch: {
        'dataset.data.description'(val) {
            const maxLength = 500;
            
            if (!val) {
                this.dataset.data.description = '';
            return;
            }

            if (val.length > maxLength) {
                this.dataset.data.description = val.substring(0, maxLength);
            }
        }
    },

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/ajuda");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            this.user = this.$root.user.data || this.$root.user;
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova Ajuda' : 'Detalhes da Ajuda'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Ajuda",
                disabled: false,
                to: "/ajuda",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a Ajuda?',
                title: 'Incluir Ajuda',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/helps', payload);

                this.$dialog.notify.info("Ajuda salva com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a Ajuda?',
                title: 'Atualizar Ajuda',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/helps/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Ajuda atualizada com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/helps/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                description: this.dataset.data.description,
                link: this.dataset.data.link,
                category: this.dataset.data.category,
                priority: this.dataset.data.priority,
                is_active: this.dataset.data.is_active
            }

            return data;
        },
    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>